module.exports = __webpack_public_path__ + "static/media/logo.04a6119f.jpg";